import { Search } from "lucide-react";

function Chip({ active, onClick, testid, children }) {
  return (
    <button
      data-testid={testid}
      onClick={onClick}
      className={`shrink-0 rounded-full px-4 py-2 text-sm font-medium transition-all duration-300 active:scale-95 ${
        active
          ? "bg-black text-white"
          : "border border-black/10 bg-white text-zinc-600 hover:border-black/25 hover:text-black"
      }`}
    >
      {children}
    </button>
  );
}

export default function StorefrontNav({ categories, activeSlug, onSelect, query, onQuery }) {
  return (
    <div className="sticky top-0 z-40 -mx-5 border-b border-black/5 bg-[#FBFBFB]/85 px-5 py-3 backdrop-blur-xl sm:-mx-8 sm:px-8 lg:mx-0 lg:px-0" data-testid="storefront-nav">
      <div className="relative">
        <Search className="pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-zinc-400" />
        <input
          data-testid="product-search-input"
          value={query}
          onChange={(e) => onQuery(e.target.value)}
          placeholder="Search products..."
          className="w-full rounded-full border border-black/10 bg-black/[0.045] py-2.5 pl-11 pr-4 text-sm outline-none transition-all duration-300 placeholder:text-zinc-500 focus:border-black/30 focus:bg-white focus:ring-2 focus:ring-black/10"
        />
      </div>
      <div className="scrollbar-none mt-3 flex gap-2 overflow-x-auto pb-0.5" data-testid="category-chips">
        <Chip active={activeSlug === "all"} onClick={() => onSelect("all")} testid="category-chip-all">
          All
        </Chip>
        {categories.map((c) => (
          <Chip key={c.id} active={activeSlug === c.slug} onClick={() => onSelect(c.slug)} testid={`category-chip-${c.slug}`}>
            {c.name}
          </Chip>
        ))}
      </div>
    </div>
  );
}
